import React from "react";
import Navbar from "../navbar/Navbar";

export default function Dashboard() {
  return (
    <div>
      <Navbar />
    </div>
  );
}
